import React from 'react'

import { feedbotToast, Subtitle } from '../lib/feedbotToast'

export const toastNotifyDeploySuccess = (version: string) => {
  const id = 'deploySuccess'

  const title = 'Your changes are live'

  const content = (
    <>
      <Subtitle>We successfully deployed version {version}!</Subtitle>
      <em>
        💡 Find out more about{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://docs.feedyou.ai/books/creating-a-virtual-assistant/page/version-history"
        >
          Version history
        </a>{' '}
        and{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://docs.feedyou.ai/books/creating-a-virtual-assistant/page/save-discard-deploy-preview-try"
        >
          Deployment controls
        </a>
        .
      </em>
    </>
  )

  feedbotToast.success({ title, content, id })
}

export const toastNotifySettingBotVersionFailure = (reason: string) => {
  const id = 'settingBotVersionFailure'

  const title = 'Hosting version could not be set'

  const content = 'We encountered an unknown error while trying to do so'

  feedbotToast.error({ title, content, id })
}
